<template>
  <CFormInput
    ref="input"
    type="file"
    :accept="accept"
    :disabled="disabled"
    :class="$attrs.class"
    @change="$emit('change', $event)"
  />
</template>

<script>
import { CFormInput } from '@coreui/vue-pro'

export default {
  name: 'CInputFile',
  components: { CFormInput },
  inheritAttrs: false,
  props: {
    accept: { type: String, default: '' },
    disabled: Boolean,
  },
  emits: ['change'],
}
</script>
